import React from 'react';
import ListUsers from './ListUsers';
import NewUser from './NewUser';

class Admin extends React.Component {
    constructor(props) {
        super(props);

        this.state  ={
            view: "list"
        };
    }

    showNewUserForm = async () => {
        this.setState({ view: "createUser"});
    }

    showUserList = async () => {
        this.setState({ view: "list"});
    }

    render() {
        return (
            <div>
                <div className="sidebar">
                    <button onClick={() => this.showNewUserForm()}>+ Add New User</button>
                </div>
                <div className="content">
                    { this.state.view === "list" ? <ListUsers /> : "" }
                    { this.state.view === "createUser" ? <NewUser handler={this.showUserList} /> : "" }
                </div>
            </div>
        );
    }
}

export default Admin;

